<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-job-config-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {JobModel} from "@/modules/redactor/models/worker/jobs/JobModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RJobConfigTable from "@/modules/redactor/views/worker/r-job-config-table.vue";

export default {
  name: "r-job-model-panel",
  components: {RJobConfigTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Job Config"),
    model: VueTypes.instanceOf(JobModel)
  },
  computed: {
    values() {
      if (this.model) {
        return this.model.data;
      } else {
        let model = new JobModel();
        this.$emit("update:model", model);
        return model.data;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>